<template>
  <el-container class="layout-wrapper">
    <el-aside width="200px" class="layout-aside">
      <app-menu />
    </el-aside>

    <el-container class="layout-right">
      <el-header height="60px" class="layout-header">
        <app-header />
      </el-header>

      <el-main class="layout-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AppMenu from '@/components/common/AppMenu.vue'
import AppHeader from '@/components/common/AppHeader.vue'

export default {
  name: 'Layout',
  components: { AppMenu, AppHeader }
}
</script>

<style scoped>
.layout-wrapper {
  height: 100vh;
  display: flex;
}
.layout-aside {
  background: #fff;
  border-right: 1px solid #e6e6e6;
}
.layout-right {
  display: flex;
  flex-direction: column;
}
.layout-header {
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
  padding: 0;
}
.layout-main {
  background-color: #f0f2f5; /* 背景灰色，区分内容区 */
  padding: 20px;
  overflow-y: auto; /* 只有内容区自己滚动 */
}
</style>